import { useMemo } from 'react';
import RowHeaderCell from './RowHeaderCell';
import { Group } from 'react-konva';
import { ReturnTypeofSheetSectionsSelector } from '../../../selectors/sheetUiSelector';
import { UseSheetTheme } from '../../../hooks/useSheetTheme';
import { UseCellSelection } from '../../../hooks/useCellSelection';
import { SelectionCell } from '../../../types';

import { getColumnRootX } from '../../../helpers/gridBoundariesHelpers';
import { getRowsCellView } from '../../../helpers/cellView/cellRows';
import { RowCellView } from '../../../helpers/cellView/cellViewTypes';

interface RowHeaderProps
  extends ReturnTypeofSheetSectionsSelector,
    Pick<UseCellSelection, 'onCellMouseDown' | 'onActiveHeaderMouseDown'>,
    Pick<UseSheetTheme, 'stroke' | 'getHeaderFill' | 'isRtl' | 'isDarkTheme'> {
  sheetId: string;
  gridWidth: number;
}
const RowHeader: React.FC<RowHeaderProps> = (props) => {
  const {
    gridWidth,
    sheetId,
    // viewport,
    defaultRowHeight,
    rowHeaderWidth,
    // groupBarHeight,
    colHeaderHeight,
    colFilterHeight,
    freezedRowsSum,
    freezedRows,
    selections,
    stroke,
    isRtl,

    rowViewport,

    zoom,
    isDarkTheme,
    filterResults,

    getHeaderFill,
    onCellMouseDown,
    onActiveHeaderMouseDown,
  } = props;

  // #region views
  const renderHeader = ({ ri, height, y }: RowCellView) => {
    filterResults.filterIndexesMap[ri];

    const headerFill = getHeaderFill(
      selections,
      ri,
      SelectionCell.Row,
      filterResults.filterIndexesMap[ri] !== undefined
      // actualRowIndex <= lastFilteredRow
    );
    return (
      <RowHeaderCell
        key={`${sheetId}-Row-${ri}`}
        x={getColumnRootX(0, gridWidth, rowHeaderWidth, isRtl)}
        y={y}
        width={rowHeaderWidth}
        height={height}
        rowIndex={ri}
        zoom={props.zoom}
        stroke={stroke}
        onCellMouseDown={onCellMouseDown}
        onActiveHeaderMouseDown={onActiveHeaderMouseDown}
        {...headerFill}
      />
    );
  };
  // #endregion

  const Headers = useMemo(() => {
    if (rowHeaderWidth <= 0) return null;

    return getRowsCellView(props, renderHeader);
  }, [
    // zoom,
    isRtl,
    gridWidth,
    sheetId,
    // colHeaderHeight,
    // colFilterHeight,
    rowViewport,
    // rowHeaderWidth,
    // rows,
    // defaultRowHeight,
    // freezedRows,
    // freezedRowsSum,
    selections,
    isDarkTheme,
    // stroke,
    // getHeaderFill,
    onCellMouseDown,
  ]);

  return <Group>{Headers}</Group>;
};

export default RowHeader;
